import { render, staticRenderFns } from "./SettingsAccount.vue?vue&type=template&id=6611a1b0&scoped=true&"
import script from "./SettingsAccount.vue?vue&type=script&lang=js&"
export * from "./SettingsAccount.vue?vue&type=script&lang=js&"
import style0 from "./SettingsAccount.vue?vue&type=style&index=0&id=6611a1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6611a1b0",
  null
  
)

export default component.exports